<div class="info-card" *ngIf="(message || '') != ''">

  <div class="row d-flex">
    <div class="col-12">
      <div class="d-inline-block p-1 pl-2">
        <mat-icon class="icon-bottom-sheet float-left">question_answer</mat-icon>
      </div>

      <div class="d-inline-block p-4">
        {{ message }}
      </div>
    </div>

    <div class="col-12">
      <div mat-dialog-actions class="row">
        <div class="col-6">
          <button  mat-flat-button color="accent" (click)="yesClick()" [mat-dialog-close]="true" cdkFocusInitial>Yes</button>
        </div>
        <div class="col-6 text-right">
          <button mat-stroked-button (click)="noClick()">No</button>
        </div>


      </div>
    </div>


  </div>
</div>
